<template>
  <el-form
    :model="formData"
    :rules="rules"
    ref="formData"
    label-position="left"
    label-width="0px"
    class="demo-ruleForm login-container"
  >
    <h3 class="title">开发调试</h3>
    <el-form-item prop="deviceId">
      <el-input type="text" v-model="formData.deviceId" auto-complete="off" placeholder="设备编号"></el-input>
    </el-form-item>
    <el-form-item style="width:100%;">
      <el-button type="primary" style="width:100%;" @click.native.prevent="handleSubmit">发送启动指令</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  data() {
    return {
      formData: {
        deviceId: ""
      },
      rules: {
        deviceId: [
          { required: true, message: "请输入设备编号", trigger: "blur" }
        ]
      },
      checked: true
    };
  },
  created: function() {
    document.title = "开发调试工具";
  },
  methods: {
    handleSubmit(ev) {
      this.$refs.formData.validate(valid => {
        if (valid) {
          var params = {};
          params.deviceId = this.formData.deviceId;
          this.api.admin.device.devstart(params).then(response => {
            if (!response.data.errorCode) {
              this.$message({
                message: "指令发送成功！",
                type: "success"
              });
            }
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style scoped>
.login-container {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  margin: auto;
  height: 220px;
  width: 350px;
  padding: 15px;
  border-radius: 5px;
  background-clip: padding-box;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
}

.title {
  margin: 10px auto 30px;
  text-align: center;
  color: #505458;
  font-size: 18px;
}

.remember {
  margin: 0px 0px 35px 0px;
}
</style>


// WEBPACK FOOTER //
// devtools.vue?57f58b9a